import { computed, onMounted, ref, watch } from 'vue';

import { useStore, useCurrentOrg } from '..';
import { useSubscription } from '../subscription';
import { trackPurchase } from '@/utils';

export function useCurrentOrgSubscription(shouldLoad = true) {
  const store = useStore();
  const isLoading = ref(false);

  const {
    numberOfProfiles,
    numberOfUsers,
    hasAnalyticsAddon,
    plan,
    freeAfter,
    customerId,
  } = useCurrentOrg();
  const customer = computed(() =>
    store.getters['organizations/getField']('customer'),
  );
  const churnkeyHash = computed(() => customer.value?.churnkey_hash);

  const {
    address,
    customerData,
    isFreePlan,
    planName,
    planInterval,
    subscription,
    subscriptionStatus,
    isTrialing,
    trialEndDate,
    isPastDue,
    isAnalyticsAddonIncluded,
    nextInvoice,
    nextPaymentAttemptDate,
    hasFreeAfter,
    freeAfterDate,
    ...rest
  } = useSubscription({ plan, customer, freeAfter });

  watch([hasFreeAfter, plan, isFreePlan], () => {
    if (shouldLoad) load();
  });

  async function load() {
    isLoading.value = true;

    await store.dispatch('organizations/getCustomerData');

    isLoading.value = false;
  }

  onMounted(() => {
    if (shouldLoad) load();
  });

  async function track() {
    if (!subscription.value) await load();
    if (subscription.value)
      trackPurchase(subscription.value.stripe_id, subscription.value.items);
  }

  return {
    ...rest,
    address,
    plan,
    customerData,
    isFreePlan,
    planName,
    planInterval,
    numberOfProfiles,
    numberOfUsers,
    hasFreeAfter,
    freeAfterDate,
    nextInvoice,
    nextPaymentAttemptDate,
    subscription,
    subscriptionStatus,
    isTrialing,
    trialEndDate,
    isPastDue,
    hasAnalyticsAddon,
    isAnalyticsAddonIncluded,
    load,
    isLoading,
    track,
    customerId,
    churnkeyHash,
  };
}
